import * as Yup from 'yup';
import { Copy } from '../copy/Copy';

export const ADD_ACTIVITY_VALIDATION_SCHEMA = Yup.object({
  date: Yup.date().required(Copy.generate('Errors.required')),
  distance: Yup.number()
    .min(0.1)
    .max(99)
    .required(Copy.generate('Errors.required')),
  activity: Yup.string().required(Copy.generate('Errors.required')),
  mood: Yup.number().optional(),
});
